
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#FFF","stroke-width":"2","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"opacity":".5","stroke-linecap":"round","d":"M2 4h17"}}),_c('path',{attrs:{"opacity":".25","stroke-linecap":"round","d":"M1 14h16"}}),_c('rect',{attrs:{"fill":"#0E0D13","x":"1","y":"1","width":"6","height":"6","rx":"3"}}),_c('rect',{attrs:{"stroke-opacity":".75","fill":"#0E0D13","x":"13","y":"11","width":"6","height":"6","rx":"3"}})])])
          )
        }
      }
    